import React, { useState, useEffect } from 'react';
import { notificarError, notificarMsg } from './Almacenes/AlmacenNotify';

const UsuarioCajas = ({ Usuario, closeModal }) => {
    const [cajas, setCajas] = useState(Usuario.Cajas);

    useEffect(() => {
        getCajas();
    }, []);

    const getCajas = async () => {
        const response = await fetch(`/api/usuarios/${Usuario.IdUsuario}/cajas?IdSucursal=${Usuario.IdSucursal}`);
        const data = await response.json();
        setCajas(data);
    }

    const onToggleCaja = async (IdCaja) => {
        const caja = cajas.find(caja => caja.IdCaja === IdCaja);
        caja.Activo = !caja.Activo;
        setCajas([...cajas]);
    }

    const onToggleAll = () => {
        const allActive = cajas.every(caja => caja.Activo);
        const newCajas = cajas.map(caja => ({
            ...caja,
            Activo: !allActive
        }));
        setCajas(newCajas);
    }

    const onGuardar = async () => {
        const response = await fetch(`/api/usuarios/${Usuario.IdUsuario}/cajas`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Cajas: cajas.map(caja => ({
                    IdCaja: caja.IdCaja,
                    Activo: caja.Activo
                })),
                IdSucursal: Usuario.IdSucursal
            })
        });

        if (response.ok) {
            notificarMsg("Configuración de cajas guardada correctamente.");
            if (closeModal) closeModal();
        } else {
            notificarError("Error al guardar la configuración de cajas.");
        }
    }

    const allActive = cajas && cajas.length > 0 ? cajas.every(caja => caja.Activo) : false;
    const someActive = cajas && cajas.length > 0 ? cajas.some(caja => caja.Activo) : false;

    return (
        <div className='px-3 mt-2'>
            <div>
                <div class="form-check mt-3">
                    <input class="form-check-input" type="checkbox" value="" id="all" checked={allActive} onChange={onToggleAll} />
                    <label class="form-check-label" for="all">
                        {allActive ? "Deshabilitar todas" : "Habilitar todas"}
                    </label>
                </div>
                <hr/>
                {cajas && cajas.map((caja) => (
                    <div key={caja.IdCaja} class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id={`caja-${caja.IdCaja}`} checked={!!caja.Activo} onChange={() => onToggleCaja(caja.IdCaja)} />
                        <label class="form-check-label" for={`caja-${caja.IdCaja}`}>{caja.Nombre}</label>
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-end mt-3 mb-3">
                <button
                    className="btn btn-verde-mfp-letra-normal"
                    onClick={onGuardar}
                >
                    Guardar
                </button>
            </div>
        </div>
    )
}

export default UsuarioCajas;
